var ProductListPaginationState = require('./hpe.productlist.pagination.model.base');

/**
 * Product List Pagination Model
 */
module.exports = ProductListPaginationState.extend({

    /**
     * state properties
     */
    props: {
        'labelPagination': 'string',
        'labelPrevious': 'string',
        'labelNext': 'string'
    },

    /**
     * derived properties
     */
    derived: {
        previousDisabled: {
            deps: ['previousPage'],
            fn: function() {
                return (this.previousPage === -1);
            }
        },
        nextDisabled: {
            deps: ['nextPage'],
            fn: function() {
                return (this.nextPage === -1);
            }
        }
    }
});

